import { BaseEntity } from 'yt-ng-framework';

export class AngazovanjeRo extends BaseEntity {
    constructor() {
        super();
    }
    RadnoVremeID: number = 1;
    // Radno vreme inicijalno je puno
    DelovodnikID: number = null;
    MestoRadaID: number = null;
    RadnoMestoID: number = null;
    PodvrstaDokumentaStavkaID: number = null;
    TataID: number = null;
    StatusRoID: number = null;
    RazlogPrestankaRoID: number = null;
    SistRadnihMestaID: number = null;
    ValutaID: number = 1;
    OsobaID: number = null;
    ObjekatID: number = null;
    BeneficiraniID: number = null;
    OrgJedRadaID: number = null;
    Broj: number = null;
    Datum: Date = null;
    OdDatuma: Date = null;
    DoDatuma: Date = null;
    KoefZarade: number = 0;
    NetoZarada: number = 0;
    BrutoZarada: number = 0;
    PrcAng: number = 100;
    NedFondSati: number = 40;
    BrutoCenaSata: number = 0;
    NetoCenaSata: number = 0;
    BrojSmena: number = 0;
    BrojPoslodavaca: number = 1;
    Ugovoren: boolean = null;
    ImaAnex: boolean = null;
    ImaRaskid: boolean = null;
    BrojAnexa: number = 0;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.RadnoVremeID=input.RadnoVremeID;
        this.DelovodnikID = input.DelovodnikID;
        this.MestoRadaID = input.MestoRadaID;
        this.RadnoMestoID = input.RadnoMestoID;
        this.PodvrstaDokumentaStavkaID = input.PodvrstaDokumentaStavkaID;
        this.TataID = input.TataID;
        this.StatusRoID = input.StatusRoID;
        this.RazlogPrestankaRoID = input.RazlogPrestankaRoID;
        this.SistRadnihMestaID = input.SistRadnihMestaID;
        this.ValutaID = input.ValutaID;
        this.OsobaID = input.OsobaID;
        this.ObjekatID = input.ObjekatID;
        this.BeneficiraniID = input.BeneficiraniID;
        this.OrgJedRadaID = input.OrgJedRadaID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.OdDatuma = input.OdDatuma;
        this.DoDatuma = input.DoDatuma;
        this.KoefZarade = input.KoefZarade;
        this.NetoZarada = input.NetoZarada;
        this.BrutoZarada = input.BrutoZarada;
        this.PrcAng = input.PrcAng;
        this.NedFondSati = input.NedFondSati;
        this.BrutoCenaSata = input.BrutoCenaSata;
        this.NetoCenaSata = input.NetoCenaSata;
        this.BrojSmena = input.BrojSmena;
        this.BrojPoslodavaca = input.BrojPoslodavaca;
        this.Ugovoren = input.Ugovoren;
        this.ImaAnex = input.ImaAnex;
        this.ImaRaskid=input.ImaRaskid;
        this.BrojAnexa=input.BrojAnexa;

        return this;
    }

    Serialize(input: AngazovanjeRo) {
        return input;
    }
}
